// src/layout/DashboardLayout.jsx
import { Layout } from "antd";
import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { logoutSuccess } from "../store/slices/authSlice";
import { resetAll as resetFile } from "../store/slices/fileSlice";
import { persistor } from "../store";
import Sidebar from "./Sidebar";

const { Content } = Layout;

const DashboardLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    try {
      // Purge persisted redux state
      try { await persistor.purge(); } catch (e) {}
      // Clear browser storage
      try { localStorage.clear(); } catch (e) {}
      try { sessionStorage.clear(); } catch (e) {}
      try { sessionStorage.removeItem("analyticsConfig"); } catch (e) {}

      // Reset redux slices
      dispatch(resetFile());
      dispatch(logoutSuccess());

      toast.success("Successfully logged out!");
    } finally {
      navigate("/login", { replace: true });
    }
  };

  return (
    <Layout className="w-full min-h-[100dvh] bg-transparent">
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        navigate={navigate}
        handleLogout={handleLogout}
      />

      <Layout className="bg-transparent min-h-0">
        <Content className="bg-transparent min-h-0">
          <div className="min-h-0 w-full flex items-start justify-center p-4 md:p-6 overflow-auto">
            <div className="w-full max-w-[1400px]">
              <Outlet />
            </div>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;